import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../core/state/app.state';
import { selectAuth } from '../../core/state/auth/auth.selector';
import {
  MainPermission,
  Permission,
} from '../../core/interfaces/permision.interface';

@Directive({
  selector: '[hasPermission]',
})
export class HasPermissionDirective {
  private permissionId: number | null = null;
  private hasView = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private store: Store<AppState>
  ) {}

  @Input() set hasPermission(permissionId: number) {
    this.permissionId = permissionId;
    this.updateView();
  }

  private updateView(): void {
    if (this.permissionId === null) {
      return;
    }

    this.store.select(selectAuth).subscribe((profile) => {
      const hasPermission = profile?.rol?.permisos_principales?.some(
        (mainPermission: MainPermission) =>
          mainPermission.permisos.some(
            (permission: Permission) => permission.id === this.permissionId
          )
      );

      if (hasPermission && !this.hasView) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.hasView = true;
      } else if (!hasPermission && this.hasView) {
        this.viewContainer.clear();
        this.hasView = false;
      }
    });
  }
}
